import React, { FC, useMemo } from "react";
import { JCMSBanner, JCMSBannerProps } from "./../JCMSBanner";
import './JProjectIntro.scss';
import { breakpointsMax } from "../../../breakpoints";
import {
    useWindowSize,
} from '@react-hook/window-size';

export const JProjectIntro: FC<JCMSBannerProps> = props => {
    const [width] = useWindowSize();
    const align: {
        leftSide: JCMSBannerProps['leftSideAlign']
        rightSide: JCMSBannerProps['rightSideAlign']
    } = useMemo(() => {
        if (width < breakpointsMax.md) {
            return {
                leftSide: 'center',
                rightSide: 'center'
            }
        }
        return {
            leftSide: 'left',
            rightSide: 'right'
        }
    }, [width])
    return (
        <JCMSBanner
            {...props}
            className="jproject-intro"
            leftSideAlign={align.leftSide}
            rightSideAlign={align.rightSide}
        />
    )
}